import { request } from '../request';

const deviceApi = {
  /**
   * 获取门店设备列表
   */
  getDeviceList() {
    return request<DeviceItem[]>({ path: '/pad/device/v2/getDeviceList' });
  },
  /**
   * 通过ID获取设备信息
   */
  getDeviceInfoById(deviceId: string) {
    return request<DeviceItem>({ path: '/pad/device/v1/get', query: { deviceId } });
  },
  /**
   * 获取二维码
   */
  getQRCode() {
    return request<GetQRCodeResponse>({ path: '/pad/device/v1/getQRCode' });
  },
  /**
   * 获取二维码状态
   */
  getQRCodeState(key: string) {
    return request<GetQRCodeStateResponse>({
      path: '/pad/device/v1/getQRCodeState',
      query: { key },
    });
  },
  /**
   * 获取机器的连接信息
   */
  getConnectionInfo(deviceId: string) {
    return request<GetConnectionInfoResponse>({
      path: '/pad/device/v1/getConnectionInfo',
      query: { deviceId },
    });
  },
  /**
   * 升级机器版本
   */
  upgradeVersion(deviceId: string) {
    return request<boolean>({
      path: '/pad/device/v1/upgrade',
      method: 'POST',
      query: { deviceId },
    });
  },
  /**
   * 获取门店设备列表，不包含设备状态
   */
  getStoreDeviceList() {
    return request<GetStoreDeviceListResponse[]>({ path: '/pad/device/v1/list/store/device' });
  },
  /**
   * 获取单个机器的底盘状态信息
   */
  getChassisStateByDeviceId(deviceId: string) {
    return request<GetChassisStateByDeviceIdResponse>({
      path: '/pad/device/v1/getChassisState',
      query: { deviceId },
    });
  },
  getVoiceCommand(serviceOrderId: string) {
    return request<GetVoiceCommandResponse>({
      path: '/pad/device/v1/voice/command',
      query: { serviceOrderId },
    });
  },
  /**
   * 关机设备
   * @param deviceId
   * @returns
   */
  shutDownDevice(deviceId: string) {
    return request<boolean>({
      path: '/pad/device/v1/shutdown',
      method: 'GET',
      query: { deviceId },
    });
  },
  /**
   * 点击我知道了关闭电源
   * @param deviceId
   * @returns
   */
  hintShutDown(deviceId: string) {
    return request<boolean>({
      path: '/pad/device/v1/shutdown/hint',
      method: 'GET',
      query: { deviceId },
    });
  },
};

export default deviceApi;
